import { render } from "./SectionServices.vue?vue&type=template&id=3905dbd8&ts=true"
import script from "./SectionServices.vue?vue&type=script&lang=ts"
export * from "./SectionServices.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__